import React from "react";
import "./ConferenceHall.scss";
import SectionTitle2 from "../../components/SectionTitle/SectionTitle2";

const ConferenceHall = () => {
  return (
    <>
    
   {/* <SectionTitle2 title="Conference Hall" /> */}


   <section className="conference-hall">
      <div className="container">
        <h1 className="page-title">conference-hall</h1>

        <div className="info-card">
          <h2>Conference Hall</h2>
          <p>
            Our modern, fully-equipped conference hall is
            designed to host seminars, workshops, meetings, and academic
            discussions. Featuring advanced audio-visual systems{" "}
            and comfortable seating, it provides an ideal
            setting for conferences, presentations, and professional
            interactions.
          </p>
          
        </div>

        {/* <div className="info-card">
          <h2>Legal Services Clinic</h2>
          <p>
            The Legal Services Clinic plays a vital role in
            practical legal education. It offers students hands-on exposure to
            real-world legal issues, promoting legal awareness,
             social responsibility, and access to justice.
            Guided by faculty, students develop essential advocacy and legal
            skills through community engagement.
          </p>
        </div> */}

        {/* <div className="info-card">
          <h2>Class Rooms</h2>
          <p>
            Our spacious and well-ventilated classrooms are
            designed to foster an engaging and interactive learning environment.
            With natural light, comfortable seating,
            and ample space, they support academic excellence
            and encourage collaboration between students and faculty.
          </p>

          <p>
            These classrooms provide a supportive and focused atmosphere{" "}
            where students can concentrate on their studies and actively
            participate in learning.
          </p>
        </div> */}
      </div>
    </section>
    </>
  
  );
};

export default ConferenceHall;
